import React, { useState, useEffect, useMemo, useRef } from "react";
import './prepLaunchPod.css';
import "react-datepicker/dist/react-datepicker.css";
import { useTimezoneSelect, allTimezones } from "react-timezone-select";
import JDCreateModal from "./JDCreateModal";
import ResumeModal from "./ResumeModal";
import JdDetailsModal from "./JDDetailsModal";
import useAuthService from '../../services/AuthService';
import LoadTransitionPage from "./loadingpage/LoadTransitionPage";
import { jsPDF } from "jspdf";
import config from "../../config.json";
import ResumePreview from './ResumePreview';
import { useAuthContext } from "../Auth/AuthContext";
import { ChevronDown, FileText, Linkedin, MoveRight, Plus, Upload } from "lucide-react";
import Notification from "./Notification";
import JDLoadingScreen from "./JDLoadingScreen";
import TransitionPage from "./TransitionPage";
import BotGuruQueuePage from "./loadingpage/BotGuruQueuePage";


const MockLaunchPod = ({ isOpen, closeModal }) => {
    const { userObjId, profileData, userAnalytics,setJdData,jdData,resumes,setResumes,timezone} = useAuthContext(); // Get userObjId from context
    const [activeButton, setActiveButton] = useState('Job/Role');
    const [activePersona, setActivePersona] = useState(null);
    const [isCreateModalOpen, setCreateModalOpen] = useState(false); // New JDCreateModal state
    const [resumeModal,setresumeModal] = useState(false);
    const closeresumeModal = () => setresumeModal(false);
    const [isJDDetailsModalOpen, setJDDetailsModalOpen] = useState(false);
    const [selectedJDId, setSelectedJDId] = useState(null);
    const [selectedCard, setSelectedCard] = useState({ interview: 'technical' });
    const authService = useAuthService();
    const [resumeData, setResumeData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [showPreview, setShowPreview] = useState(false);
    const [previewData, setPreviewData] = useState(null); 
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [showNotification, setShowNotification] = useState(false);
    const [notificationMessage, setNotificationMessage] = useState('');
    const [notificationDismissed, setNotificationDismissed] = useState(false);
    const [showQueue,  setShowQueue]  = useState(false); // spinner / error
    const [queueError, setQueueError] = useState(false); // “no” path
    const [showTransition, setShowTransition] = useState(false);   // NEW
    const firstRender = useRef(true);           // ← guards the initial mount
    const prevIsLoading  = useRef(false);  // remembers last isLoading value
    const [urlArrived, setUrlArrived] = useState(false);
    const iframeOpenRequested = useRef(false);



    useEffect(() => {
        const handleOpComplete = (e) => {
            if (e.data === 'operationComplete') {
                iframeOpenRequested.current = true;   // flip the flag
            }
        };

        window.addEventListener('message', handleOpComplete);
        return () => window.removeEventListener('message', handleOpComplete);
    }, []);

    useEffect(() => {
        // ⛔️ skip the very first paint
        if (firstRender.current) {
            firstRender.current = false;
            return;
        }

        /* Show the fallback ONLY when
           1) the real loader just finished   (true → false)
           2) we’re not in the queue overlay
           3) we have NOT yet received the final URL */
        if (prevIsLoading.current && !isLoading && !showQueue && !urlArrived) {
            setShowTransition(true);
        }

        // remember last value for the next run
        prevIsLoading.current = isLoading;
    }, [isLoading, showQueue, urlArrived]);

    useEffect(() => {
        if (isOpen && showNotification && !notificationDismissed) {
            setShowNotification(true);
        } else {
            setShowNotification(false);
        }
    }, [isOpen]);

    const handleCloseNotification = () => {
        setNotificationDismissed(true);  // Mark it as dismissed
        setShowNotification(false);
    };

    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    };

    const now = new Date();
    const date = now.toISOString().split("T")[0]; // Extract date in YYYY-MM-DD format
    const time = now.toTimeString().split(" ")[0]; // Extract time in HH:MM:SS format
    useEffect(() => {
        console.log("Updated userObjId in MockLaunchPod:", userObjId);
      }, [userObjId]);

    const generateRandom5DigitNumber = () => {
        return Math.floor(10000 + Math.random() * 90000);
    };
    const generateJD_ID=()=>{
        let ID= `Job ${(jdData && jdData.length+1<10) ? `0${jdData.length+1}` : jdData.length+1}`;
        return ID;
    }

    const generateResume_ID=()=>{
        let ID= `Resume ${(resumes!=null && resumes.length+1<10) ? `0${resumes.length+1}` : resumes.length+1}`;
        return ID;
    }

    const [formData, setFormData] = useState({
        "job_role": "",
        company: "",
        job_type: "",
        job_description: {
            about_us: "",
            job_overview: "",
            key_responsibilities: "",
            required_qualification_experience: "",
            preferred_skills: ""
        },
        date: date,
        time: time,
        jd_id: generateRandom5DigitNumber()
    });

    const [disabledButtons, setDisabledButtons] = useState({
        'Job/Role': false, 
        'Resume': true, 
        'Persona': true, 
        'Launch': true
    });
    


    const sectionKeys = {
        'Job/Role': 'jobRole',
        'Resume': 'resume',
        'Persona': 'persona',
        'Launch': null, // No selection needed for Launch
    };

    const handleCloseModal = () => {
        // Reset state
        setSelectedCard({});
        setActiveButton('Job/Role');
        setActivePersona(null); // Reset persona selection
        // Add other state resets as needed
        setDisabledButtons({
            'Job/Role': false,
            'Resume': true,
            'Persona': true,
            'Launch': true
        })
        // Close modal logic
        closeModal();
    };


    const websocketUrlForFileUpload = "wss://jvplqszjpi.execute-api.us-west-2.amazonaws.com/production/"; // WebSocket for File upload

    const handleFileChange = (event) => {
        const file = event.target.files[0];
        if (!file) {
            console.error("No file selected.");
            return;
        }

        console.log("File selected:", file);
        handleFileUpload(file);
        event.target.value = null; // Clear the input after handling
    };

    const handleFileUpload = (file) => {
        setLoading(true);
        setShowDropDown(false);
        // setresumeModal(true);
        console.log("Initializing WebSocket for Resume Upload...");

        const websocketInstance = new WebSocket(websocketUrlForFileUpload);

        websocketInstance.onopen = () => {
            console.log("WebSocket connection established for Resume Upload.");
            const message = { action: "botguru_sendmessage", message: "get data" };
            sendWebSocketMessageWithRetry(websocketInstance, message);
        };
        websocketInstance.onmessage = (event) => handleWebSocketMessage(event, file);

        websocketInstance.onerror = (error) => {
            console.error("WebSocket error for Resume Upload:", error);
        };

        websocketInstance.onclose = () => {
            console.log("WebSocket connection closed for Resume Upload.");
        };
    };

    const handleWebSocketMessage = async (event, file) => {
        if (!event.data || event.data.trim() === "") {
            console.warn("Empty WebSocket message received.");
            return;
        }

        try {
            const data = JSON.parse(event.data);
            console.log("WebSocket message received:", data);
            setLoading(true);
            if (data.connectionid) {
                // Step 1: Call authService to extract resume data
                const response = await authService
                    .resumeExtractor({
                        file,
                        connectionId: data.connectionid,
                        user_obj_id:userObjId,
                    });

                console.log("Resume extraction initiated successfully:", response);

                // Wait for the full resume data in subsequent WebSocket messages
            } else if (data.message) {
                // Step 2: Full resume data received
                const messageData = data.message;
                console.log("Complete resume data received:", messageData);

                // Step 3: Set the parsed resume data
                // setResumeData(data);

                // Step 4: Open the modal
                // setresumeModal(true);
                await handleResumeUploadSubmit(data);
                setLoading(false);
                
            }
        } catch (error) {
            console.error("Error handling WebSocket message:", error);
            setNotificationMessage(error?.data?.error ?? "Error Parsing resume Data, please try again.");
            setShowNotification(true);
            setLoading(false);
            setresumeModal(false);
        }
    };

    const formatDateToMonthYear = (date) => {
        if (!date) return '';
        const d = new Date(date);
        
        // Always return the formatted date
        return d.toLocaleDateString('en-US', { month: 'short', year: 'numeric' });
    };

    const handleResumeUploadSubmit = async (resumeData) => {
        console.log("here")
        const now = new Date();
        const date = now.toISOString().split("T")[0]; // Extract date in YYYY-MM-DD format
        const time = now.toTimeString().split(" ")[0]; // Extract time in HH:MM:SS format
      
        const resumeId = resumeData?.message?.resumeId || generateResume_ID();        
        console.log("Generated resumeId:", resumeId);

        const {first_name, last_name, linkedin_url, phone_number, professional_summary, skills, website_url, education, email, experience } = resumeData?.message;

        console.log("resume data", resumeData?.message);
        const payload = {
            // resume_id:resumeId,
            user_obj_id:userObjId,
            // user_id: "email8@email.com", // Replace with dynamic user email if needed
            resume_name: "test.png",
            data: date,
            time: time,
            resumeId: resumeId,
            resume: {
                personalDetails: {
                    firstName: first_name ?? "Not Provided",
                    lastName: last_name ?? "Not Provided",
                    email: email ?? "Not Provided",
                    phoneNumber: phone_number ?? "Not Provided",
                    linkedIn: linkedin_url ?? "Not Provided",
                    website: website_url ?? "Not Provided",
                    summary: professional_summary ?? "Not Provided",
                },
                experiences: experience?.map((experience) => ({
                    jobTitle: experience.job_role || "Not Provided",
                    companyName: experience.company_name || "Not Provided",
                    startDate: experience.start_date
                    ? formatDateToMonthYear(experience.start_date)
                    : "Not Provided",
                    endDate: experience.end_date
                    ? formatDateToMonthYear(experience.end_date)
                    : "Not Provided",
                    description: experience?.responsibilities.join("\n") || "",
                    skills: [...experience.skills] || [],
                    domain: experience.domain || "Not Provided",
                    location: experience.location || "Not Provided",
                    country: experience.country || "Not Provided",
                })),
                skills: skills || [],
                education: education.map((edu) => ({
                    school: edu.school_university || "Not Provided",
                    degree: edu.degree || "Not Provided",
                    startDate: edu.start_date
                    ? formatDateToMonthYear(edu.start_date)
                    : "Not Provided",
                    endDate: edu.end_date
                    ? formatDateToMonthYear(edu.end_date)
                    : null,
                    gpa: edu.gpa || "Not Provided",
                    city_state: edu.city_state || "",
                    country: edu.country || "",
                    additionalDetails: edu.additionalDetails || "",
                })),
            },
        };
        if (resumeData?.message?.res_obj_id){
            console.log("resume_obj_if added")
            payload['res_obj_id'] = resumeData.message.res_obj_id;
        }
        else{
            console.log("new resume")
        }
        try {
            const response = await authService.saveResume(payload);
            // console.log("Resume saved successfully:", response);

            fetchResumes(resumeId);

        } catch (error) {
            console.error("Error submitting resume:", error);
            // setErrorMessage("Failed to save resume. Please try again.");
        }
    };


    const sendWebSocketMessageWithRetry = (websocketInstance, message, retries = 3, interval = 1000) => {
        let attempts = 0;

        const sendMessage = () => {
            if (websocketInstance.readyState === WebSocket.OPEN) {
                websocketInstance.send(JSON.stringify(message));
                console.log("WebSocket message sent:", message);
            } else if (attempts < retries) {
                attempts++;
                console.log(`WebSocket not ready. Retrying (${attempts}/${retries})...`);
                setTimeout(sendMessage, interval);
            } else {
                console.error("Failed to send WebSocket message after multiple attempts.");
            }
        };

        sendMessage();
    };

    const handleJDFileChange = (event) => {
        const file = event.target.files[0];
        if (!file) {
            console.error("No file selected.");
            return;
        }
    
        console.log("File selected:", file);
    
        // Trigger the upload process with the selected file
        handleJDFileUpload(file);
        event.target.value = null;
    };
    
      const handleJDFileUpload = (file) => {
        if (!file) {
            console.error("No file selected. Aborting upload.");
            return;
        }
        setLoading(true);
        setShowDropDown(false);
        // setCreateModalOpen(true)
        console.log("Initializing WebSocket for File Upload...");
        const websocketInstance = new WebSocket(websocketUrlForFileUpload);
    
        websocketInstance.onopen = () => {
            console.log("WebSocket connection established for File Upload.");
            const message = { action: "botguru_sendmessage", message: "get data" };
            sendWebSocketMessageWithRetry(websocketInstance, message);
        };
    
        websocketInstance.onmessage = (event) => handleWebSocketMessageForFileUpload(event, file);
    
        websocketInstance.onerror = (error) => {
            console.error("WebSocket error for File Upload:", error);
        };
    
        websocketInstance.onclose = () => {
            console.log("WebSocket connection closed for File Upload.");
        };
    };
    
    const handleWebSocketMessageForFileUpload = async (event, file) => {
      // if (!event.data || event.data.trim() === "") {
      //     console.warn("Empty WebSocket message received.");
      //     return;
      // }
    
      try {
          const data = JSON.parse(event.data);
          console.log("WebSocket message received:", data);
    
          if (data.connectionid) {
              const formData = new FormData();
              formData.append("file", file);
              formData.append("connectionId", data.connectionid);
              formData.append("user_obj_id", userObjId);
    
              console.log("Sending file data via API...");
              await authService
                  .jobDescriptionExtractor({
                      file,
                      connectionId: data.connectionid,
                      user_obj_id:userObjId,
                  })
                  .then((response) => {
                      console.log("API Response from jobDescriptionExtractor:", response);
                  })
                  .catch((error) => {
                      console.error("Error uploading file to /jobDescriptionExtractor:", error);
                      setNotificationMessage(error?.data.error ?? "Error Parsing Job Description, Please try again.");
                      setShowNotification(true);
                      setLoading(false);
                      setCreateModalOpen(false);
                    //   setUploadError({...uploadError, JDUploadError:"Your uploaded JD document exceeded size limit"});
                  });
          }
    
          if (data.message) {
            try {
                const parsedMessage = JSON.parse(data.message);
                console.log("Parsed Message:", parsedMessage);

                let new_jd_id=generateJD_ID();
                await handleSubmit(parsedMessage, new_jd_id);
                setLoading(false);
            } catch (parseError) {
                console.error("Error parsing message:", parseError);
            }
        }
      } catch (error) {
          console.error("Error handling WebSocket message:", error);
      }
    };

    const handleSubmit = async (parsedMessage, new_jd_id) => {
        try {

            const payload = {
                user_obj_id:userObjId,
                // user_id: "email8@email.com",
                "job_role": parsedMessage.job_role ?? "Not Provided",
                company: parsedMessage.company  ?? "Not Provided",
                job_type: parsedMessage.job_type ?? "Not Provided" ,
                job_description: {
                    about_us: parsedMessage.job_description.about_us || "Not Provided",
                    job_overview: parsedMessage.job_description.job_overview || "Not Provided",
                    key_responsibilities: parsedMessage.job_description.key_responsibilities || "Not Provided",
                    required_qualification_experience: parsedMessage.job_description.required_qualification_experience || "Not Provided",
                    preferred_skills: parsedMessage.job_description.preferred_skills || "Not Provided"
                },
                date: formData["date"],
                time: formData["time"],
                experience: parsedMessage.job_description.experience || "Not Provided",
                salary: parsedMessage.job_description.salary || "Not Provided",
                currency:formData?.currency ?? "USD" ,
                location: parsedMessage.job_description.location ?? "Not Provided",
                jd_id: new_jd_id,
            };

            const response = await authService.saveJobDetails(payload);
            // console.log("Job Details Saved:", response);

            if (response.error) {
                console.error("Error saving job details:", response.error);
                alert("Failed to save job details. Please try again.");
            } else {
                await fetchJobRoles(payload.jd_id); // Refresh JD list in PrepLaunchPod
            }
        } catch (error) {

            console.error("Error saving job details:", error);
        }
    };



    const openJDDetailsModal = (jdId) => {
        if (!jdId || !jdData || !Array.isArray(jdData)) {
            console.log("Invalid data for modal", { jdId, jdData });
            return;
        }
        setSelectedJDId(jdId);
        setJDDetailsModalOpen(true);
    };


    const closeJDDetailsModal = () => {
        setSelectedJDId(null);
        setJDDetailsModalOpen(false);
    };


    const handleCardSelection = (section, cardId) => {
        setSelectedCard((prev) => ({
            ...prev,
            [section]: cardId,
        }));
        if (section === 'jobRole') {
            // If Job/Role is selected, enable Resume and disable Persona and Launch
            setDisabledButtons({
                'Job/Role': false,
                'Resume': false, // Enable Resume
                'Persona': true, // Disable Persona
                'Launch': true   // Disable Launch
            });
        } else if (section === 'resume') {
            // If Resume is selected, enable Persona and disable Launch
            setDisabledButtons({
                'Job/Role': false,
                'Resume': false, // Enable Resume
                'Persona': false, // Enable Persona
                'Launch': true    // Disable Launch
            });
        }
    };

    const fetchResumes = async (id=null) => {
        setLoading(true);
        try {
            const response = await fetch(`${config.restAPI}/resume/getResumes/`, {
                method: "POST",
                credentials:"include",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    user_obj_id: userObjId,
                }),
            });

            if (!response.ok) {
                throw new Error(`Failed to fetch resumes. Status: ${response.status}`);
            }

            const data = await response.json();
            console.log("Fetched Resumes:", data.resumes);    
            const sortedResumes = data.resumes.sort((a, b) => {
                const aDate = new Date(a.created_at);
                const bDate = new Date(b.created_at);
                return bDate - aDate; // Latest first (descending order)
            });
    
            // console.log("Sorted Resumes by created_at:", sortedResumes);
            setResumes(sortedResumes || []);
            if(id){
                let selectResumeData = sortedResumes.find((each)=>each.resume_id===id)
                if(selectResumeData) handleCardSelection("resume", selectResumeData._id);
            }
        } catch (error) {
            console.error("Error fetching resumes:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if(resumes.length===0){
            fetchResumes()
        }
    }, []);

    const handlePersonClick=(personaVal)=>{
        console.log("calling person Click", personaVal)
        setActivePersona(personaVal);
        setSelectedCard((prev) => ({
            ...prev,
            persona: personaVal,
            // interview: 'prepbot'
        }));
        setDisabledButtons({
            'Job/Role': false,
            'Resume': false,
            'Persona': false,
            'Launch': false
        });
        // if(personaVal===0){
        //     setActivePersona(0)
        // }
        // if(personaVal===1){
        //     setActivePersona(1)
        // }
        // setSelectedCard((prev) => ({
        //     ...prev,
        //     persona: personaVal, // Add/update the persona key
        // }));
        // setDisabledButtons({
        //     'Job/Role': false,
        //     'Resume': false,
        //     'Persona': false,
        //     'Launch': false // Enable Launch
        // });
    }

    const personaData=[
        // {
        //     id:"1",
        //     url:"/new_york_female.png"
        // },
        // {
        //     id:"2",
        //     url:"/san_francisco_male.png"
        // },
        // {
        //     id:"3",
        //     url:"/new_york_indian.png"
        // },
        {
            id:"4",
            url:"/new_york_male.png"
        }
        // ,
        // {
        //     id:"5",
        //     url:"/new_york_female2.png"
        // }
      ]
      const getPersonaUrl=(id)=>{
        const persona=personaData.find((persona)=>persona.id===id);
        return persona.url;
      }

    const buttons = [
        { id: 1, name: 'Job/Role', label: 'Job Description' },
        { id: 2, name: 'Resume', label: 'Resume' },
        { id: 3, name: 'Persona', label: 'Persona' },
        { id: 4, name: 'Launch', label: 'Launch' },
    ];

    const sections = ['Job/Role','Resume', 'Persona', 'Launch'];
    const currentSectionIndex = sections.indexOf(activeButton);

    const handleNext = () => {
        if (currentSectionIndex < sections.length - 1) {
            setActiveButton(sections[currentSectionIndex + 1]);
        }
    };

    const handlePrevious = () => {
        if (currentSectionIndex > 0) {
            setActiveButton(sections[currentSectionIndex - 1]);
        }
    };


    const fetchJobRoles = async (id=null) => {
        setLoading(true);
        try {
            const response = await fetch(`${config.restAPI}/jd/getJobs/`, {
                method: "POST",
                credentials:"include",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    user_obj_id: userObjId,
                }),
            });

            if (!response.ok) {
                throw new Error(`Failed to fetch job roles. Status: ${response.status}`);
            }
            
            const data = await response.json();
            console.log(data);
            const sortedData = data.job_descriptions.sort((a, b) => {
                const aDate = new Date(a.created_at);
                const bDate = new Date(b.created_at);
                return bDate - aDate; // Latest first
            });
    
            console.log("Sorted JDs by created_at:", sortedData);
            setJdData(sortedData || []);
            if(id){
                let selectJobData = sortedData.find((each)=>each.jd_id===id)
                if(selectJobData) handleCardSelection("jobRole", selectJobData._id);
            }
        } catch (error) {
            console.error("Error fetching job roles:", error);
            setJdData([]); // Set empty array on error
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if(jdData.length===0){
        fetchJobRoles();
        }
    }, []);

    const renderNewJobRoleCard = () => {
        return (
            <div className="pod-upload-card"  onClick={() => setCreateModalOpen(true)}>
            <FileText className="card-icon" />
            <div className="card-details">
                <p className="card-title">Create Job Description</p>
                <span className="card-subtitle">Start from scratch using AI</span>
            </div>
        </div>
        );
    }

    const renderLinkedinJobRoleCard=()=>{
        return (
            <div className="pod-upload-card import-upload-card">
                <Linkedin className="card-icon" />
                <div className="card-details">
                    <p className="card-title">Import Job from Linkedin</p>
                    <span className="card-subtitle">Paste Job Posting URL</span>
                </div>
            </div>
        )
    }

    const renderJobUploadRoleCard = () => {
        return (
            <div className="pod-upload-card" onClick={()=>document.getElementById("fileInput").click()}>
                <Upload className="card-icon" />
                <div className="card-details">
                    <p className="card-title">Upload Job Description</p>
                    <span className="card-subtitle">PDF, DOCX (Max 5 pages)</span>
                </div>
                <input
                    id="fileInput"
                    type="file"
                    accept=".docx,.pdf"
                    style={{ display: 'none' }}
                    onChange={handleJDFileChange}
                />
            </div>
        );
    };

    const renderUploadResumeCard = () => {
        
        return(
                <div className="pod-upload-card" onClick={()=>document.getElementById("fileInput").click()}>
                    <Upload className="card-icon" />
                    <div className="card-details">
                        <p className="card-title">Upload Resume</p>
                        <span className="card-subtitle">PDF, DOCX (Max 5 pages)</span>
                    </div>
                    <input type="file" accept=".pdf,.docx"
                            style={{display:"none"}}
                            id="fileInput"
                            onChange={handleFileChange}
                        />
                </div>
            )};

    const renderNewResumeCard = () =>{
        return  (
                    <div className="pod-upload-card" onClick={() => {
                            setResumeData(null);
                            setresumeModal(true);
                        }}>
                        <FileText className="card-icon" />
                        <div className="card-details">
                            <p className="card-title">Create Resume with AI</p>
                            <span className="card-subtitle">Build from scratch Using AI</span>
                        </div>
                    </div>
        )};


    const renderJobRoleCards = () => {
        if (!jdData || jdData.length === 0) {
            return (
                <div className="no-jd-data-box">
                    <div className="no-jd-data">
                        <i className="fas fa-inbox id-icon"></i>
                        <h2>No Job Descriptions Yet</h2>
                        <p>
                        To kick off your new mock session, please upload an existing job description or create one using our AI-assisted generator!
                        </p>
                    </div>
                </div>
                
            );
        }
        
        return (
            <div className="jdlist-card-container">
                {jdData.map((jd) => ( 
                    <div 
                        className={`launch-jd-card ${selectedCard.jobRole === jd._id ? 'selected' : ''}`}
                        key={jd._id}
                        onClick={() => handleCardSelection('jobRole', jd._id)}
                    >
                        <div className="launch-card-details">
                        <div className="launch-jd-heading">
                            <div className="launch-jd-title">
                            <h3 className="launch-jd-badge">{jd.job_role}</h3>
                            <span className="launch-jd-info-value">
                                {/* <i className="fas fa-hashtag id-icon"></i> */}
                                <span className="launch-jd-id-number">#{jd.jd_id}</span>
                            </span> 
                            </div>
        
                        <div className="launch-jd-info-row">
                        <div className="launch-jd-info-item">
                                
                                <div className="launch-jd-info-value">
                                    <i className="far fa-clock company-icon"></i>
                                    <span>{new Date(jd.created_at).toLocaleDateString('en-US', { day:'numeric', year: 'numeric', month: 'short' })}</span>
                                </div>
                            </div>
                            <div className="launch-jd-info-item">
                                {/* <span className="jd-info-label">Company</span> */}
                                <div className="launch-jd-info-value">
                                    <i className="fas fa-building company-icon"></i>
                                    <span className="jd-company-name">{jd.company || 'Not Provided'}</span>
                                </div>
                            </div>
                            <div className="launch-jd-info-item">
                                <div className="launch-jd-info-value">
                                    <i className="fas fa-business-time company-icon"></i>
                                    {jd.job_type|| 'Not Provided'}
                                </div>
                            </div>
                             <div className="launch-jd-info-item">
                                <div className="launch-jd-info-value">
                                    <i className="fas fa-briefcase company-icon"></i>
                                    {jd.experience || 'Not Provided'}
                                </div>
                            </div>
                        </div>
                        </div>
                        <div className="launch-view" onClick={(e) => {
                                        e.stopPropagation();
                                        openJDDetailsModal(jd._id);
                                    }}>
                        <i className="fas fa-chevron-right view-icon"  ></i>
                        </div>
                    </div>
                    </div>
                ))}
            </div>
        );
        
    };

    const renderLinkedinResumeCard=()=>{
        return (
            <div className="pod-upload-card import-upload-card">
                <Linkedin className="card-icon" />
                <div className="card-details">
                    <p className="card-title">Import Profile from Linkedin</p>
                    <span className="card-subtitle">Paste Your Profile URL</span>
                </div>
            </div>
        )
    }

    const handleViewResume = (resumeData) => {
        // Transform the resume data to match ResumePreview's expected format
        const transformedData = {
            message: {
                first_name: resumeData.resume.personalDetails.firstName,
                last_name: resumeData.resume.personalDetails.lastName,
                email: resumeData.resume.personalDetails.email,
                phone_number: resumeData.resume.personalDetails.phoneNumber,
                linkedin_url: resumeData.resume.personalDetails.linkedIn,
                website_url: resumeData.resume.personalDetails.website,
                professional_summary: resumeData.resume.personalDetails.summary,
                experience: resumeData.resume.experiences?.map(exp => ({
                    job_role: exp.jobTitle,
                    company_name: exp.companyName,
                    start_date: exp.startDate,
                    end_date: exp.endDate,
                    city_state: exp.location,
                    responsibilities: exp.description?.split('\n')
                })),
                skills: resumeData.resume.skills,
                education: resumeData.resume.education?.map(edu => ({
                    school_university: edu.school,
                    degree: edu.degree,
                    start_date: edu.startDate,
                    end_date: edu.endDate,
                    gpa: edu.gpa,
                    additionalDetails: edu.additionalDetails
                }))
            }
        };
        
        setPreviewData(transformedData);
        setShowPreview(true);
    };


    const calculateTotalExperience = (experiences) => {
        if (!experiences || experiences.length === 0) return 'No experience';
    
        let totalMonths = 0;
        
        experiences.forEach((exp,index) => {
            const startDate = parseDate(exp.startDate);
            const endDate = (exp.endDate === 'Present' || exp.endDate === 'Current' || (exp.endDate === 'Invalid Date' && index===0) || (exp.endDate === "Not Provided" && index===0) ) ? new Date() : parseDate(exp.endDate);
            
            if (startDate && endDate) {
                const months = (endDate.getFullYear() - startDate.getFullYear()) * 12 + 
                              (endDate.getMonth() - startDate.getMonth());
                totalMonths += months;
            }
        });
        const years = Math.round(totalMonths / 12);
        return years ? `${years}+ years` : "NA";
    };
    
    const parseDate = (dateStr) => {
        if (!dateStr) return null;
        if (dateStr === 'Present') return new Date();
        
        const [month, year] = dateStr.split(' ');
        const monthIndex = new Date(Date.parse(month + " 1, 2000")).getMonth();
        return new Date(parseInt(year), monthIndex);
    };

    

    const renderResumeCards = () => {
        if (!resumes || resumes.length === 0) {
            return (
                <div className="no-jd-data-box">
                <div className="no-jd-data">
                    <i className="fas fa-inbox id-icon"></i>
                    <h2>No Resumes Yet</h2>
                    <p>
                    To kick off your new mock session, please upload an existing resume or create one using our AI-assisted generator!
                    </p>
                </div>
                </div>
            );
        }
    
        return (
            <div className="resumelist-card-container">
                {resumes.map((resumeData) => {
                    const resume = resumeData.resume;
                    return (
                        <div 
                            className={`launch-resume-card ${selectedCard.resume === resumeData._id ? 'selected' : ''}`}
                            key={resumeData._id}
                            onClick={() => handleCardSelection('resume', resumeData._id)}
                        >
                        <div className="launch-card-details">
                        <div className="launch-jd-heading">
                            <div className="launch-jd-title">
                            <h3 className="launch-jd-badge">{resume.experiences?.[0]?.jobTitle || 'No Job Title'}</h3>
                            <span className="launch-jd-info-value">
                                {/* <i className="fas fa-hashtag id-icon"></i> */}
                                <span className="launch-jd-id-number">#{resumeData.resume_id}</span>
                            </span> 
                            </div>

                        

                            <div className="launch-jd-info-row">
                                <div className="launch-jd-info-item">
                                    <div className="launch-jd-info-value">
                                         <i className="far fa-clock company-icon"></i>
                                        {new Date(resumeData.last_updated).toLocaleDateString('en-US', { day: 'numeric', year: 'numeric', month: 'short' })}
                                    </div>
                                </div>
                                <div className="launch-jd-info-item">
                                    <div className="launch-jd-info-value">
                                    <i className="fas fa-briefcase company-icon"></i>
                                        {calculateTotalExperience(resume.experiences)}
                                    </div>
                                </div>
                                <div className="launch-skills-list">
                                <i className="fas fa-code company-icon"></i>
                                {resume.skills && resume.skills.length > 0 ? (
                                        resume.skills.slice(0, 4).map((skill, index) => (
                                            <span key={index} className="skill-tag">
                                                {skill}
                                            </span>
                                        ))
                                    ) : (
                                        <span className="info-value">Skills not provided</span>
                                    )}
                                </div>
                            </div>
                        </div>
                        <div className="launch-view"  onClick={(e) => {
                                            e.stopPropagation();
                                            handleViewResume(resumeData);
                        }} >
                        <i className="fas fa-chevron-right view-icon" ></i>
                        </div>
                        </div>
                        </div>
                    );
                })}
            </div>
        );
    };


    // Update the selectedJD declaration with more detailed checks
    const selectedJD = useMemo(() => {
        
        if (!jdData || !Array.isArray(jdData)) {
            return null;
        }
        
        if (!selectedCard.jobRole) {
            return null;
        }

        const found = jdData.find(jd => jd._id === selectedCard.jobRole);
        return found || null;
    }, [jdData, selectedCard.jobRole]);

    const [interviewType, setInterviewType]= useState("skill");
    const renderInterviewTypeContent=()=>{
        let interviewTypeData=[
            {   
                id:"skill",
                "text":"Skill"
            },
            {
                id:"skill_exp",
                "text":"Skill & Experience"
            }
        ]
        return (
            <div className="interview-type-content">
                {interviewTypeData.map((type, index)=>{
                    return (
                        <button key={type.id} 
                                onClick={()=>setInterviewType(type.id)}
                            className={`pod-btns interview-type ${interviewType===type.id ? "selected" : ""}`}>
                            {type.text}
                        </button>
                    )
                    })
                }
            </div>
        )
    }
        const [showDropDown, setShowDropDown]= useState(false);
        const dropdownRef=useRef(null);
        const buttonRef= useRef(null);
        useEffect(() => {
            const handleOutsideClick = (event) => {
              // If click is outside the button and dropdown, close the dropdown.
              if (
                dropdownRef.current && !dropdownRef.current.contains(event.target) &&
                buttonRef.current && !buttonRef.current.contains(event.target)
              ) {
                console.log(buttonRef.current)
                setShowDropDown(false);
              }
            };
        
            if (showDropDown) {
              document.addEventListener('mousedown', handleOutsideClick);
            } else {
              document.removeEventListener('mousedown', handleOutsideClick);
            }
            return () => {
              document.removeEventListener('mousedown', handleOutsideClick);
            };
          }, [showDropDown]);

    return (
        <>
            {/*{isLoading && <LoadTransitionPage  url="https://botguru.ai:5174/" setIsLoading={setIsLoading} />} /!* Pass setIsLoading *!/*/}
            {/* step‑1  queue overlay */}
            {showQueue && (
                <BotGuruQueuePage
                    error={queueError}
                    onBack={() => { setShowQueue(false); setQueueError(false); }}
                />
            )}

            {/* 2️⃣ first loader that hits botguru.ai:5174 */}
            {isLoading && (
                <LoadTransitionPage
                    url="https://botguru.ai:5174/"
                    setIsLoading={setIsLoading}
                />
            )}

            {/* 3️⃣ fallback page AFTER loader ends but BEFORE URL arrives */}
            {/*{!showQueue && !isLoading && showTransition && (*/}
            {/*    <TransitionPage setShowTransitionPage={setShowTransition} />*/}
            {/*)}*/}
            {!showQueue && !isLoading && showTransition && (
                <TransitionPage
                    setShowTransitionPage={setShowTransition}
                    cancel={urlArrived}          // tells it to dismiss immediately
                />
            )}


            {/* 4️⃣ normal PrepLaunchPod UI */}
            {!showQueue && !isLoading && !showTransition && (
                <div className="modal-overlay">
                {
                    <>
                        {loading && <JDLoadingScreen />}
                        <div className="launch-modal-content" onClick={(e) => e.stopPropagation()}>
                            <button className="completed-close-button" onClick={handleCloseModal}>
                                &times;
                            </button>

                            <div className='right-launch-page'>
                            <div className="path">
                                   {
                                    buttons.map((button, index)=>(
                                        <div className={`path-item ${activeButton===button.name ? "active" : ""} ${disabledButtons[button.name] ? "unactive" : ""}`}                                            
                                        onClick={() => {
                                            if(!disabledButtons[button.name]){
                                                setActiveButton(button.name);
                                            }
                                        }}>
                                        <span className="step_numb">{index+1}</span>
                                            <span>{button.label}</span>
                                        </div>
                                    ))
                                   }
                            </div>
                                {activeButton==='Job/Role' &&
                                    <div className="launch-right">
                                    <div className="launch-right-header">
                                        <h1 className="pod-title">Select or Upload Job Description</h1>
                                        <div className="upload-create-btn-container"                                                
                                            onMouseEnter={()=>setShowDropDown(true)} 
                                            onMouseLeave={()=>setShowDropDown(false)}>
                                        <button className="upload-create-btn" ref={buttonRef} 
                                            onClick={()=>setShowDropDown(true)} 
                                            >
                                        <Plus className="btn-icon" />
                                            <span>Add New Job</span>
                                            <ChevronDown className={`drop-down-icon ${showDropDown ? "active" : ""}`} />
                                        </button>
                                        { showDropDown &&
                                            <div className="drop-down-container" ref={dropdownRef}>
                                                <div className="upload-create-cards">
                                                {renderJobUploadRoleCard()} 
                                                {renderNewJobRoleCard()}
                                                {/* {renderLinkedinJobRoleCard()} */}
                                            </div>
                                        </div>}
                                        </div>
                                    </div>

                                     {jdData.length !== 0 && <h1 className="pod-title">Recent Job Descriptions</h1>}
                                        {/* <div className="jdlist-card-container "> */}
                                        {renderJobRoleCards()}
                                        {/* </div> */}
                                </div>
                                }
                                {activeButton==='Resume' &&
                                    <div className="launch-right">
                                        <div className="launch-right-header">
                                            <h1 className="pod-title">Select or Upload Resume</h1>
                                            <div className="upload-create-btn-container"                                                
                                                onMouseEnter={()=>setShowDropDown(true)} 
                                                onMouseLeave={()=>setShowDropDown(false)}>
                                                <button className="upload-create-btn" ref={buttonRef} 
                                                onClick={()=>setShowDropDown(true)} 
                                                >
                                                <Plus className="btn-icon" />
                                                    <span>Add New Resume</span>
                                                    <ChevronDown className={`drop-down-icon ${showDropDown ? "active" : ""}`} />
                                                </button>
                                                { showDropDown &&
                                                    <div className="drop-down-container" ref={dropdownRef}>
                                                    <div className="upload-create-cards">
                                                        {renderUploadResumeCard()}
                                                        {renderNewResumeCard()}
                                                        {/* {renderLinkedinResumeCard()} */}
                                                    </div>
                                                </div>}
                                            </div>
                                         </div>
                                         {resumes.length !== 0 && <h1 className="pod-title">Recent Resumes</h1>}
                                        {renderResumeCards()}
                                    </div>
                                }
                                {activeButton==='Persona' &&
                                    <div className="launch-right">
                                        <h1 className="pod-title">Select Your Trainer</h1>
                                        {/* <h4 className="pre-sub-title">Selected Trainer would be conducting your session</h4> */}
                                        <div className="persona-container">
                                        {
                                                personaData.map(({id,url}, index)=>{
                                                    return (
                                                        <div className={`persona-field ${activePersona === id ? 'active' : ''}`} key={id} onClick={()=>handlePersonClick(id)}>
                                                            <img src={`/Bots/${url}`} alt="persona" />
                                                        </div>
                                                    )
                                                })
                                            }
                                            {/* <div className="persona-name">
                                                <button className={`persona ${activePersona === 0 ? 'active' : ''}`}  onClick={()=>handlePersonClick(0)}>
                                                    <img src="Leo.jpg" alt="leo"></img>
                                                </button>
                                                <h1>Leo</h1>
                                            </div> */}

                                            {/* <div className="persona-name">
                                                <button className={`persona ${activePersona === 1 ? 'active' : ''}`} onClick={()=>handlePersonClick(1)}>
                                                    <img src="malebot.png" alt="leo"></img>
                                                </button>
                                                <h1>Jordan</h1>
                                            </div> */}
                                        </div>
                                        {/* <div className="interview-type">
                                            <h1 className="content-heading">Select Interview Type</h1>
                                            {renderInterviewTypeContent()} 
                                        </div> */}
                                    </div>}
                                {activeButton==='Launch' &&
                                    <div className="launch-right">

                                <h1 className="pod-title">Overview of your selection</h1>
                                {/* <h4 className="pre-sub-title">Please review the selected Job/Role, Resume and Interviewer for your mock session:</h4> */}
                                
                                <div className="selected-cards-container">
                                {/* Selected JD Card */}
                                    {selectedCard.jobRole && jdData && selectedJD && (
                                    <div className="launch-jd-card selected">
                                    <div className="launch-card-details">
                                    <div className="launch-jd-heading">
                                    <div className="launch-jd-title">
                                    <h3 className="launch-jd-badge"> {jdData.find(jd => jd._id === selectedCard.jobRole)?.job_role || "Not Provided"}</h3>
                                    <span className="launch-jd-info-value">
                                        {/* <i className="fas fa-hashtag id-icon"></i> */}
                                        <span className="launch-jd-id-number">#{jdData.find(jd => jd._id === selectedCard.jobRole)?.jd_id || ""}</span>
                                    </span> 
                                    </div>
                                   
                                

                                <div className="launch-jd-info-row">
                                <div className="launch-jd-info-item">
                                        
                                        <div className="launch-jd-info-value">
                                            <i className="far fa-clock company-icon"></i>
                                            <span>{new Date(jdData.find(jd => jd._id === selectedCard.jobRole)?.created_at).toLocaleDateString('en-US', { day:'numeric',year: 'numeric', month: 'short' })}</span>
                                        </div>
                                    </div>
                                    <div className="launch-jd-info-item">
                                        {/* <span className="jd-info-label">Company</span> */}
                                        <div className="launch-jd-info-value">
                                            <i className="fas fa-building company-icon"></i>
                                            {jdData.find(jd => jd._id === selectedCard.jobRole)?.company || "Not Provided"}
                                        </div>
                                    </div>
                                    <div className="launch-jd-info-item">
                                        <div className="launch-jd-info-value">
                                            <i className="fas fa-business-time company-icon"></i>
                                            {jdData.find(jd => jd._id === selectedCard.jobRole)?.job_type || "Not Provided"}
                                        </div>
                                    </div>
                                    <div className="launch-jd-info-item">
                                        <div className="launch-jd-info-value">
                                            <i className="fas fa-briefcase company-icon"></i>
                                            {jdData.find(jd => jd._id === selectedCard.jobRole)?.experience || "Not Provided"}
                                        </div>
                                    </div>
                                </div>
                                </div>
                                <div className="launch-view"   onClick={(e) => {
                                        e.stopPropagation();
                                        openJDDetailsModal(selectedCard.jobRole)
                                    }}>
                                <i className="fas fa-chevron-right view-icon"></i>
                                </div>
                                </div>
                                </div>
                                    )}

                                {/* Selected Resume Card */}
                                {selectedCard.resume && (
                                    <div className="launch-resume-card selected">
                                    <div className="launch-card-details">
                                    <div className="launch-jd-heading">
                                        <div className="launch-jd-title">
                                        <h3 className="launch-jd-badge">{resumes.find(resume => resume._id === selectedCard.resume)?.resume.experiences?.[0]?.jobTitle || 'No Job Title'}</h3>
                                        <span className="launch-jd-info-value">
                                            {/* <i className="fas fa-hashtag id-icon"></i> */}
                                            <span className="launch-jd-id-number">#{resumes.find(resume => resume._id === selectedCard.resume)?.resume_id}</span>
                                        </span> 
                                        </div>

                                        <div className="launch-jd-info-row">
                                            <div className="launch-jd-info-item">
                                                <div className="launch-jd-info-value">
                                                    <i className="far fa-clock company-icon"></i>
                                                    {new Date(resumes.find(resume => resume._id === selectedCard.resume)?.last_updated).toLocaleDateString('en-US', { day:'numeric',year: 'numeric', month: 'short' })}
                                                </div>
                                            </div>
                                            <div className="launch-jd-info-item">
                                                <div className="launch-jd-info-value">
                                                <i className="fas fa-briefcase company-icon"></i>
                                                {calculateTotalExperience(resumes.find(resume => 
                                                                resume._id === selectedCard.resume)?.resume.experiences)}
                                                </div>
                                            </div>
                                            <div className="launch-skills-list">
                                            <i className="fas fa-code company-icon"></i>
                                            {(() => {
                                                const skills = resumes.find(resume => resume._id === selectedCard.resume)?.resume.skills;
                                                    return skills && skills.length > 0 ? (
                                                        skills.slice(0, 4).map((skill, index) => (
                                                                    <span key={index} className="launch-skill-tag">
                                                                        {skill}
                                                                    </span>
                                                                ))
                                                            ) : (
                                                                <span className="launch-skill-tag">Skills not provided</span>
                                                            );
                                                        })()}
                                            </div>
                                        </div>
                                </div>
                                <div className="launch-view"   onClick={(e) => {
                                                    e.stopPropagation();
                                                    const selectedResume = resumes.find(resume => 
                                                        resume._id === selectedCard.resume);
                                                    handleViewResume(selectedResume);
                                                }}>
                                <i className="fas fa-chevron-right view-icon"></i>
                                </div>
                                </div>
                                </div>
                                )}

                                {/* Selected Persona */}
                                {activePersona !== null && (
                                    <div className="launch-persona-container">
                                        <div className={`persona-preview active`} key={activePersona}>
                                            <img src={`/Bots/${getPersonaUrl(activePersona)}`} alt="persona" />
                                        </div>
                                        {/* <div className="persona-name">
                                            <div className={`launch-persona ${activePersona === 0 ||activePersona === 1 ? "active" : ""}`}>
                                                <img
                                                    src={activePersona === 0 ? "Leo.jpg" : "malebot.png"}
                                                    alt={activePersona === 0 ? "Female launch-Persona" : "Male launch-Persona"}
                                                />
                                            </div>
                                            <h2>{activePersona === 0 ? "Leo" : "Jordan"}</h2>
                                        </div> */}
                                    </div>
                                )}
                                </div>

                                        {/*<div className="launch-btn-container">*/}
                                        {/*<button class="prev-button"  onClick={handlePrevious}>Previous</button>    */}
                                        {/*<button className="launch-button">Launch</button>*/}
                                        {/*</div>*/}
                                        <div className="launch-btn-container">
                                            <button className="prev-button button" onClick={handlePrevious}>Previous</button>
                                            <button
                                                className="launch-button button"
                                                disabled={ userAnalytics?.mockbot_total<=userAnalytics?.mockbot_used  || selectedCard.resume==null || selectedCard.jobRole==null}
                                                onClick={() => {
                                                    // setIsLoading(true);
                                                    setUrlArrived(false);     // 🚿 fresh run → no URL yet
                                                    setShowTransition(false); // make sure old fallback is gone
                                                    setShowQueue(true);        // show spinner immediately
                                                    setQueueError(false);

                                                    const websocketUrl = "wss://ycbrz3lmnc.execute-api.us-west-2.amazonaws.com/production/";
                                                    const websocket = new WebSocket(websocketUrl);
                                                    let newUrl = null; // Store the new URL temporarily

                                                    websocket.onopen = () => {
                                                        console.log("WebSocket connection established.");
                                                        const message = {action: "SendMessage", message: "get data"};
                                                        websocket.send(JSON.stringify(message));
                                                    };

                                                    websocket.onmessage = async (event) => {
                                                        try {
                                                            if (!event.data || event.data.trim() === "") {
                                                                console.warn("Received empty or irrelevant WebSocket message.");
                                                                return;
                                                            }
                                                            const data = JSON.parse(event.data);
                                                            if (data === "go") {
                                                                setShowQueue(false);   // hide spinner
                                                                setShowTransition(false);   // <- hide it for a fresh run
                                                                setIsLoading(true);    // open transition page
                                                            }
                                                            else if (data === "no") {
                                                                setQueueError(true);   // switch spinner → error + Go Back
                                                            }
                                                            if (data.connectionid) {
                                                                console.log("Connection ID received:", data.connectionid);

                                                                // Retrieve full content of the selected JD
                                                                const selectedJDContent = jdData?.find(
                                                                    jd => jd._id === selectedCard.jobRole
                                                                ) || {message: "No JD Selected"};

                                                                // Retrieve full content of the selected Resume
                                                                const selectedResumeContent = resumes.find(
                                                                    resume => resume._id === selectedCard.resume
                                                                ) || {message: "No Resume Selected"};

                                                                // Extract user information from the selected resume
                                                                const userEmail = selectedResumeContent.resume?.personalDetails?.email || "email8@email.com";
                                                                const userName = selectedResumeContent.resume?.personalDetails
                                                                    ? `${selectedResumeContent.resume.personalDetails.firstName} ${selectedResumeContent.resume.personalDetails.lastName}`
                                                                    : "User";
                                                                const resumeId = selectedResumeContent.resume_id || "00001";

                                                                // Helper function to format JSON as resume-like text
                                                                const formatJsonAsText = (json) => {
                                                                    const traverse = (obj) => {
                                                                        return Object.entries(obj)
                                                                            .map(([key, value]) => {
                                                                                if (typeof value === "object" && value !== null) {
                                                                                    return traverse(value); // Recursively handle objects
                                                                                } else if (Array.isArray(value)) {
                                                                                    return `• ${key}: ${value.join(", ")}`;
                                                                                } else {
                                                                                    return `• ${key}: ${value}`;
                                                                                }
                                                                            })
                                                                            .join("\n");
                                                                    };
                                                                    return traverse(json);
                                                                };

                                                                // Convert JD and Resume JSON to formatted text

                                                                const jobDescriptionText = (selectedJDContent.job_description || {});
                                                                console.log("Job Description Text:", jobDescriptionText);
                                                                const resumeText = formatJsonAsText(selectedResumeContent.resume || {});
                                                                const resume_obj_id = (selectedResumeContent._id || {});
                                                                const job_role = (selectedJDContent.job_role || {});
                                                                const job_id = (selectedJDContent.jd_id || {});
                                                                const job_obj_id = (selectedJDContent._id || {});

                                                                // Generate a random user ID
                                                                const generateRandomUserId = () => {
                                                                    const array = new Uint8Array(12); // Generate 12 random bytes
                                                                    window.crypto.getRandomValues(array);
                                                                    return Array.from(array, byte => byte.toString(16).padStart(2, '0')).join('');
                                                                };

                                                                // Prepare the JSON object with user details
                                                                const selectedData = {
                                                                    user_id: userObjId,        //updates with login
                                                                    user_obj_id: userObjId,    //updates with login
                                                                    userfirstname: profileData?.name,                     //updates with login
                                                                    resume_obj_id: resume_obj_id,
                                                                    job_role: job_role,
                                                                    user_email: userEmail,
                                                                    local_time: new Date().toLocaleString(),
                                                                    bot_type: 'mockbot',
                                                                    user_name: profileData?.name,
                                                                    job_description: jobDescriptionText,
                                                                    job_id: job_id,
                                                                    job_obj_id: job_obj_id,
                                                                    resume: resumeText,
                                                                    resumeId: resumeId,
                                                                    persona: activePersona !== null
                                                                        ? (activePersona === 0 ? "f" : "m")
                                                                        : "No Persona Selected",
                                                                    interviewType: interviewType || "No Interview Type Selected",
                                                                    connectionId: data.connectionid,
                                                                    region: "us-west-1",
                                                                    timezone: timezone,
                                                                };


                                                                // Log the JSON data
                                                                console.log("Selected Data JSON with User Information:", selectedData);

                                                                // Send the JSON data as a POST request
                                                                try {
                                                                    const response = await fetch(`${config.restAPI}/sessions/startSession/`, {
                                                                        method: "POST",
                                                                        credentials:"include",
                                                                        headers: {
                                                                            "Content-Type": "application/json",
                                                                        },
                                                                        body: JSON.stringify(selectedData),
                                                                    });

                                                                    if (!response.ok) {
                                                                        throw new Error(`Failed to send data. Status: ${response.status}`);
                                                                    }

                                                                    const responseData = await response.json();
                                                                    console.log("API response:", responseData);
                                                                } catch (apiError) {
                                                                    console.error("Error sending data to API:", apiError.message);
                                                                }
                                                            } else if (data.url) {
                                                                // Handle the URL case and display it as an iframe
                                                                // setIsLoading(false)
                                                                console.log("Opening URL in iframe:", data.url);
                                                                console.log(isLoading + " isLoading")
                                                                setUrlArrived(true);
                                                                setShowTransition(false); // hide <TransitionPage/>

                                                                newUrl = data.url; // Store the new URL temporarily

                                                                if (iframeOpenRequested.current === true) {
                                                                    console.log("operationComplete message received from iframe");
                                                                    iframeOpenRequested.current = true;

                                                                    // Create background overlay
                                                                    const overlay = document.createElement("div");
                                                                    overlay.style.position = "fixed";
                                                                    overlay.style.top = "0";
                                                                    overlay.style.left = "0";
                                                                    overlay.style.width = "100%";
                                                                    overlay.style.height = "100%";
                                                                    overlay.style.backgroundColor = "rgba(0, 0, 0, 0.6)";
                                                                    overlay.style.zIndex = "9998";

                                                                    // Create "Let's Start" button
                                                                    const launchButton = document.createElement("button");
                                                                    launchButton.innerText = "Let's Start";
                                                                    launchButton.style.position = "fixed";
                                                                    launchButton.style.top = "50%";
                                                                    launchButton.style.left = "50%";
                                                                    launchButton.style.transform = "translate(-50%, -50%)";
                                                                    launchButton.style.padding = "15px 25px";
                                                                    launchButton.style.fontSize = "18px";
                                                                    launchButton.style.backgroundColor = "#be01f9";
                                                                    launchButton.style.color = "#fff";
                                                                    launchButton.style.border = "none";
                                                                    launchButton.style.borderRadius = "8px";
                                                                    launchButton.style.cursor = "pointer";
                                                                    launchButton.style.zIndex = "9999";

                                                                    launchButton.onclick = () => {
                                                                        // Remove overlay and button
                                                                        document.body.removeChild(launchButton);
                                                                        document.body.removeChild(overlay);

                                                                        setTimeout(() => {
                                                                            // Create and display the iframe
                                                                            const iframeContainer = document.createElement("div");
                                                                            iframeContainer.style.position = "fixed";
                                                                            iframeContainer.style.top = "0";
                                                                            iframeContainer.style.left = "0";
                                                                            iframeContainer.style.width = "100%";
                                                                            iframeContainer.style.height = "100%";
                                                                            iframeContainer.style.backgroundColor = "rgba(0, 0, 0, 0.5)";
                                                                            iframeContainer.style.zIndex = "9999";

                                                                            const iframe = document.createElement("iframe");
                                                                            iframe.src = newUrl;
                                                                            iframe.style.width = "100%";
                                                                            iframe.style.height = "100%";
                                                                            iframe.style.border = "none";
                                                                            iframe.allow = "camera; microphone; fullscreen";

                                                                            const closeButton = document.createElement("button");
                                                                            closeButton.innerText = "Close";
                                                                            closeButton.style.position = "absolute";
                                                                            closeButton.style.bottom = "10px";
                                                                            closeButton.style.left = "10px";
                                                                            closeButton.style.zIndex = "10000";
                                                                            closeButton.style.padding = "10px";
                                                                            closeButton.style.backgroundColor = "#be01f9";
                                                                            closeButton.style.color = "#fff";
                                                                            closeButton.style.border = "none";
                                                                            closeButton.style.cursor = "pointer";
                                                                            closeButton.style.borderRadius = "5px";
                                                                            closeButton.onclick = () => {
                                                                                document.body.removeChild(iframeContainer);
                                                                                window.location.href = "/landingPage/mockBot";
                                                                            };

                                                                            iframeContainer.appendChild(iframe);
                                                                            iframeContainer.appendChild(closeButton);
                                                                            document.body.appendChild(iframeContainer);
                                                                        }, 500);
                                                                    };

                                                                    document.body.appendChild(overlay);
                                                                    document.body.appendChild(launchButton);
                                                                }

                                                                const handleMessage = (event) => {
                                                                    if (event.data === "operationComplete") {
                                                                        console.log("operationComplete message received from iframe");
                                                                        iframeOpenRequested.current = true;

                                                                        // clearInterval(interval);

                                                                        // Display the new URL in an iframe
                                                                        const iframeContainer = document.createElement("div");
                                                                        iframeContainer.style.position = "fixed";
                                                                        iframeContainer.style.top = "0";
                                                                        iframeContainer.style.left = "0";
                                                                        iframeContainer.style.width = "100%";
                                                                        iframeContainer.style.height = "100%";
                                                                        iframeContainer.style.backgroundColor = "rgba(0, 0, 0, 0.5)";
                                                                        iframeContainer.style.zIndex = "9999";

                                                                        const iframe = document.createElement("iframe");
                                                                        iframe.src = newUrl;
                                                                        iframe.style.width = "100%";
                                                                        iframe.style.height = "100%";
                                                                        iframe.style.border = "none";
                                                                        iframe.allow = "camera; microphone; fullscreen"; // Allow camera and microphone access

                                                                        const closeButton = document.createElement("button");
                                                                        closeButton.innerText = "Close";
                                                                        closeButton.style.position = "absolute";
                                                                        closeButton.style.bottom = "10px";
                                                                        closeButton.style.left = "10px";
                                                                        closeButton.style.zIndex = "10000";
                                                                        closeButton.style.padding = "10px";
                                                                        closeButton.style.backgroundColor = "#be01f9";
                                                                        closeButton.style.color = "#fff";
                                                                        closeButton.style.border = "none";
                                                                        closeButton.style.cursor = "pointer";
                                                                        closeButton.style.borderRadius = "5px";
                                                                        closeButton.onclick = () => {
                                                                            document.body.removeChild(iframeContainer);
                                                                            window.location.href = "/landingPage/mockBot"; // Redirect to the specified URL
                                                                        };

                                                                        iframeContainer.appendChild(iframe);
                                                                        iframeContainer.appendChild(closeButton);
                                                                        document.body.appendChild(iframeContainer);

                                                                        window.removeEventListener("message", handleMessage); // Remove listener after use
                                                                    }
                                                                }
                                                                // const iframeContainer = document.createElement('div');
                                                                // iframeContainer.style.position = 'fixed';
                                                                // iframeContainer.style.top = '0';
                                                                // iframeContainer.style.left = '0';
                                                                // iframeContainer.style.width = '100%';
                                                                // iframeContainer.style.height = '100%';
                                                                // iframeContainer.style.backgroundColor = 'rgba(0, 0, 0, 0.5)';
                                                                // iframeContainer.style.zIndex = '9999';
                                                                //
                                                                // const iframe = document.createElement('iframe');
                                                                // iframe.src = data.url;
                                                                // iframe.style.width = '100%';
                                                                // iframe.style.height = '100%';
                                                                // iframe.style.border = 'none';
                                                                // iframe.allow = "camera; microphone; fullscreen"; // Allow camera and microphone access
                                                                //
                                                                // const closeButton = document.createElement('button');
                                                                // closeButton.innerText = 'Close';
                                                                // closeButton.style.position = 'absolute';
                                                                // closeButton.style.bottom = '10px'; // Move to the bottom
                                                                // closeButton.style.left = '10px'; // Align to the left
                                                                // closeButton.style.zIndex = '10000';
                                                                // closeButton.style.padding = '10px';
                                                                // closeButton.style.backgroundColor = '#f00';
                                                                // closeButton.style.color = '#fff';
                                                                // closeButton.style.border = 'none';
                                                                // closeButton.style.cursor = 'pointer';
                                                                // closeButton.style.borderRadius = '5px'; // Optional: Add rounded corners
                                                                // closeButton.onclick = () => {
                                                                //     document.body.removeChild(iframeContainer);
                                                                //     window.location.href = 'https://flower.botguru.ai/landingPage'; // Redirect to the specified URL
                                                                // };
                                                                //
                                                                //
                                                                //
                                                                // iframeContainer.appendChild(iframe);
                                                                // iframeContainer.appendChild(closeButton);
                                                                // document.body.appendChild(iframeContainer);
                                                                window.addEventListener("message", handleMessage);

                                                            } else {
                                                                console.log(data)
                                                                console.warn("No connection ID or URL received in WebSocket message.");
                                                            }
                                                        } catch (error) {
                                                            console.error("Error parsing WebSocket message:", error.message);
                                                        }
                                                    };

                                                    websocket.onerror = (error) => {
                                                        console.error("WebSocket error:", error);
                                                    };

                                                    websocket.onclose = () => {
                                                        console.log("WebSocket connection closed.");
                                                    };
                                                }}
                                            >
                                                <i className="fas fa-rocket launch-icon"></i>
                                                Launch
                                            </button>
                                        </div>


                                    </div>}
                                <div className="launch-navigation-buttons">
                                    {currentSectionIndex > 0 && currentSectionIndex <= 2 && (
                                        <button
                                            className="prev-button"
                                            onClick={handlePrevious}
                                        >
                                            Previous
                                        </button>
                                    )}
                                    {currentSectionIndex < sections.length - 1 && (
                                        <button
                                            className="next-button"
                                            onClick={handleNext}
                                            disabled={!selectedCard.hasOwnProperty(sectionKeys[sections[currentSectionIndex]])}
                                        >
                                            Next
                                        </button>
                                    )}
                                </div>
                            </div>
                        </div>
                    </>
                }
            </div>)};
            <JDCreateModal
                isOpen={isCreateModalOpen}
                closeModal={() => setCreateModalOpen(false)}
                refreshJDList={fetchJobRoles} initialFormData={formData} isLoading={loading}
            />;
            {resumeModal && <ResumeModal isOpen={resumeModal} closeModal={closeresumeModal} resumeData={resumeData}
                                         onResumeSubmit={() => {
                                             fetchResumes(); // Refresh the resume list
                                             setActiveButton("Resume"); // Navigate back to "Choose your Resume" page
                                             setresumeModal(false); // Ensure the modal is closed
                                         }
                                         }
                                         isLoading={loading}
            ></ResumeModal>}
            <JdDetailsModal
                isOpen={isJDDetailsModalOpen}
                closeModal={closeJDDetailsModal}
                jdId={selectedJDId}
                jdData={jdData}  // Pass the array directly
                refreshJDList={fetchJobRoles}
            />
            {showPreview && (
                <ResumePreview
                    resumeData={previewData}
                    closeModal={() => setShowPreview(false)}
                />
            )}
            {showNotification && (
                <Notification 
                    message={notificationMessage}
                    onClose={handleCloseNotification}
                />
            )}
            {/* {loading ? renderLoading() : renderNewJobRoleCard()} */}

        </>
    );
};

export default MockLaunchPod;
//